// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid--dashboard[data-v-22ba47ca] {\n  display: grid;\n  grid-auto-flow: dense;\n  grid-template-columns: repeat(auto-fill, minmax(35rem, 1fr));\n  grid-template-rows: 1fr 1fr;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
